import React from 'react';
import PropTypes from 'prop-types';
import { riskColors } from 'utils/constants/risks';
import styles from './index.module.scss';
import Map from 'components/Map';
import Image from 'components/Image';
import { images } from 'utils/icons';
import { HIGH_DETAIL_CONFIG } from '../../../utils/constants/Map';

const MapCompound = ({ value }) => {
  // FIX-ME: create a more efficient of filtering
  const polygonList = value.filter(item => item.type === 'POLYGON');
  const markers = value.filter(item => item.type === 'POINT');
  const ellipseList = value.filter(item => item.type === 'ELLIPSE');

  const centreOfGravity = value.map(item => {
    switch (item.type) {
      case 'POINT':
        return { lat: item.lat, lng: item.lng };
      case 'ELLIPSE':
        return item.center;
      case 'POLYGON':
        return item.center;
      default:
        return null;
    }
  });

  const polygons = polygonList.map(polygon => ({
    isFilled: true,
    color: riskColors[polygon.riskLevel],
    paths: polygon.boundary,
    strokeWeight: polygon.strokeWeight || HIGH_DETAIL_CONFIG.strokeWeight,
  }));
  const addressVal = value.find(item => item.address);

  const Address = ({ children }) => {
    return (
      <div className={styles.address}>
        <Image src={images.iconSite?.default} />
        {children}
      </div>
    );
  };

  const ellipses = ellipseList.map(item => ({
    ...item,
    editable: false,
    draggable: false,
    strokeWeight: item.strokeWeight || HIGH_DETAIL_CONFIG.strokeWeight,
  }));

  Address.propTypes = {
    children: PropTypes.string,
  };

  return (
    <>
      {addressVal && <Address>{addressVal.address}</Address>}
      <section className={styles.map}>
        <Map
          polygons={polygons}
          markers={markers}
          ellipses={ellipses}
          isZoomEnabled={false}
          center={centreOfGravity[0]}
          mapInForm={true}
        />
      </section>
    </>
  );
};

MapCompound.propTypes = {
  value: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
};

export default MapCompound;
